import Documents from '@/components/ui/documents/documents';
export default Documents;
